import axios from 'axios'

export default class Resource {
    constructor() {
        this.axios = axios
    }
}
